import { useRef, useState } from "react";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { MoveHorizontal } from "lucide-react";
import { imgUrl } from "@/lib/api";

export function BeforeAfter({ before: b, after: a, alt = "", testid }) {
  const before = imgUrl(b);
  const after = imgUrl(a);
  const ref = useRef(null);
  const pos = useMotionValue(50);
  const clip = useTransform(pos, (v) => `inset(0 ${100 - v}% 0 0)`);
  const left = useTransform(pos, (v) => `${v}%`);
  const [dragging, setDragging] = useState(false);

  const setFrom = (clientX) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    pos.set(Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100)));
  };

  return (
    <div
      ref={ref}
      data-testid={testid}
      className="relative aspect-square w-full cursor-ew-resize touch-none select-none overflow-hidden rounded-sm border border-[var(--line)]"
      onPointerDown={(e) => { setDragging(true); e.currentTarget.setPointerCapture(e.pointerId); setFrom(e.clientX); }}
      onPointerMove={(e) => dragging && setFrom(e.clientX)}
      onPointerUp={() => setDragging(false)}
      onPointerLeave={() => setDragging(false)}
      onMouseEnter={() => !dragging && animate(pos, [50, 62, 40, 50], { duration: 1.6, ease: "easeInOut" })}
    >
      <img src={after} alt={`Après — ${alt}`} draggable={false} className="absolute inset-0 h-full w-full object-cover" />
      <motion.img src={before} alt={`Avant — ${alt}`} draggable={false} style={{ clipPath: clip }} className="absolute inset-0 h-full w-full object-cover" />
      <span className="absolute left-4 top-4 rounded-full bg-[rgba(11,8,9,0.7)] px-3 py-1 text-[11px] uppercase tracking-[0.22em] text-[var(--parchment)] backdrop-blur-md">Avant</span>
      <span className="absolute right-4 top-4 rounded-full bg-[var(--gold)] px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-[var(--ink)]">Après</span>
      <motion.div style={{ left }} className="pointer-events-none absolute inset-y-0 w-px -translate-x-1/2 bg-[var(--gold-soft)]">
        <span className="absolute left-1/2 top-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-[var(--gold-soft)] bg-[rgba(11,8,9,0.75)] text-[var(--gold-soft)] backdrop-blur-md">
          <MoveHorizontal className="h-5 w-5" />
        </span>
      </motion.div>
    </div>
  );
}
